"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memberTeamIds = exports.memberDivisionIds = exports.commissionerDivisionIds = exports.isCommissionerOfAnything = exports.membersLoaded = exports.members = void 0;
const members = (state) => state.members;
exports.members = members;
const membersLoaded = (state) => (0, exports.members)(state).membersLoaded;
exports.membersLoaded = membersLoaded;
const isCommissionerOfAnything = (state) => (0, exports.members)(state).isCommissionerOfAnything;
exports.isCommissionerOfAnything = isCommissionerOfAnything;
const commissionerDivisionIds = (state) => (0, exports.members)(state).commissionerDivisionIds;
exports.commissionerDivisionIds = commissionerDivisionIds;
const memberDivisionIds = (state) => (0, exports.members)(state).memberDivisionIds;
exports.memberDivisionIds = memberDivisionIds;
const memberTeamIds = (state) => (0, exports.members)(state).memberTeamIds;
exports.memberTeamIds = memberTeamIds;
